import styled, { css } from 'styled-components/macro'
import { RiLogoutBoxRLine } from 'react-icons/ri'
import { FiSettings } from 'react-icons/fi'
import { BsBell } from 'react-icons/bs'

export const TopBarTitle = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  color: #ffffff;
  margin-right: 16px;
`

export const CompanyTitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  margin-right: 16px;
  line-height: 24px;
`

export const Wrapper = styled.div`
  background: #06512f;
  min-height: var(--footer-height);
  height: var(--footer-height);
  color: white;
  display: flex;
  align-items: center;
  padding: 0 60px;
  width: 100%;

  @media (max-width: 600px) {
    padding: 0 16px;
    justify-content: center;
  }
`

export const SettingsButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  &:hover {
    background: #148552;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0px 10px;
  gap: 10px;
`

const SharedButton = css`
  cursor: pointer;
  color: white;
  font-size: 28px;
  height: 45px;
  width: 45px;
  padding: 8px;
  &:hover {
    background: rgb(44, 107, 78);
  }
`

export const LogoutIcon = styled(RiLogoutBoxRLine)`
  ${SharedButton}
`

export const SettingsIcon = styled(FiSettings)`
  ${SharedButton}
`

export const BellIcon = styled(BsBell)`
  ${SharedButton}
`

export const LogoImg = styled.img`
  margin-right: 40px;
`
